import React, { useState } from 'react';
import { CreateJobDialog } from '../create-job-dialog';
import { ConfirmationModal } from 'components';
import { Grid, Typography } from '@mui/material';
import { styles as confirmationModalStyles } from 'components/confirmation-modal/confirmation-modal-helper';
import { useResetSDZDataJob } from '../../../../hooks';
import { useAuth } from '../../../../core';
import { useNavigate } from 'react-router-dom';
import { JOB_MANAGER_PATHS } from 'constants/job-manager-paths';
import { wipeOrResetSdzDataJobStyle } from 'pages/job-manager/job-manager-helper';

export const CreateResetSDZData = (): React.JSX.Element => {
    const { getToken, getUserEmail } = useAuth();
    const navigate = useNavigate();
    const { mutate: resetSDZDataJob } = useResetSDZDataJob();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [confirmationModal, setConfirmationModal] = useState<boolean>(false);

    const handleResetButton = (): void => {
        setConfirmationModal(true);
    };

    const handleConfirmationModal = (): void => {
        setConfirmationModal(false);
    };

    const handleWipeData = (): void => {
        setIsLoading(true);
        resetSDZDataJob(
            {
                token: getToken(),
                email: getUserEmail(),
            },
            {
                onSuccess: () => {
                    setTimeout(() => {
                        navigate(JOB_MANAGER_PATHS.LANDING_PAGE);
                    }, 500);
                    setIsLoading(false);
                    handleConfirmationModal();
                },
                onError: () => {
                    setIsLoading(false);
                    handleConfirmationModal();
                },
            }
        );
    };

    return (
        <>
            <CreateJobDialog
                handleSubmit={handleResetButton}
                buttonText='RESET DATA'
                isLoading={isLoading}
                customButtonContainerStyles={
                    wipeOrResetSdzDataJobStyle.customButtonContainerStyles
                }
            >
                <Grid sx={wipeOrResetSdzDataJobStyle.container}>
                    <Typography sx={wipeOrResetSdzDataJobStyle.textStyles}>
                        The reset job restores metadata back to its original
                        state, erasing all <br /> data, similar to a factory
                        reset. This action CANNOT be undone. Are <br /> you sure
                        you want to proceed?
                    </Typography>
                </Grid>
            </CreateJobDialog>
            {confirmationModal && (
                <ConfirmationModal
                    confirmationModal={confirmationModal}
                    handleConfirmationModal={handleConfirmationModal}
                    confirmationKey={'RESET'}
                    confirmationButtonText={'Reset Data'}
                    confirmationHeadingText={'Confirm Reset'}
                    confirmationInputLabelText={'Type RESET below'}
                    handleConfirmation={handleWipeData}
                    confirmationSubHeadingText={
                        <Typography>
                            By typing{' '}
                            <Typography
                                component='span'
                                sx={confirmationModalStyles.textBoldStyles}
                            >
                                ‘RESET’
                            </Typography>{' '}
                            below, you understand that you are resetting the
                            metadata back to its original state. Reset will wipe
                            and delete all metadata. This action{' '}
                            <Typography
                                component='span'
                                sx={confirmationModalStyles.textBoldStyles}
                            >
                                CANNOT
                            </Typography>{' '}
                            be undone.
                        </Typography>
                    }
                />
            )}
        </>
    );
};
